import {BaseOptions} from "../../../../dialog/options/base.options";

export class AddOrUpdateAttributeTypeOptions extends BaseOptions {
  attributeType?: any;

  onInsertOrUpdateFinished() {
  }
}
